export default {
  init() {
    // JavaScript to be fired on all pages
    $('p:empty').remove();

    // Navigation
    var $mainMenuState = $('#main-menu-state');
    if ($mainMenuState.length) {
      // animate mobile menu
      $mainMenuState.change(function(e) {
        e.preventDefault();

        var $menu = $('#menu-main-menu');
        if (this.checked) {
          $menu.slideDown();
        } else {
          $menu.slideUp();
        }
      });
    }

    var newWindowWidth = $(window).width();

    if (newWindowWidth < 767) {
      var headerMenuHeight = $('.site-header .header-menu .header-menu-class').outerHeight();
      $('.site-header .brand-wrapper').css('margin-top', headerMenuHeight);
    }

    if (newWindowWidth < 1023) {
      var $menuChildItem = $('.menu-item-has-children');

      if(!$menuChildItem.find('a:first').find('span').hasClass('sub-arrow')) {
        $menuChildItem.find('a:first').append('<span class="sub-arrow"></span>');
      }

      $('li.menu-item-has-children .sub-arrow').off('click').on('click', (function () {
        $('.menu-item-has-children').not($(this).closest('li')).removeClass('is-show');
        $(this).closest('li').toggleClass('is-show');
        $('.menu-item-has-children').not($(this).closest('li')).find('.sub-menu').slideUp();
        $(this).closest('li').find('.sub-menu').slideToggle(250);

        return false;
      }));
    }

    $('.section__text-image-table-content .text-image-table-content-wrapper .section__body .content-item.has-image .images').each(function() {
      if($(this).children().length >= 2) {
        $(this).addClass('has-multi-image');
        $(this).closest('.content-item').addClass('align-items-md-start');

        if($(this).children().length >= 4) {
          $(this).addClass('grid-boxes');
        }
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js